import { render, staticRenderFns } from "./medIntegration.vue?vue&type=template&id=728c69d0&scoped=true"
import script from "./medIntegration.vue?vue&type=script&lang=js"
export * from "./medIntegration.vue?vue&type=script&lang=js"
import style0 from "./medIntegration.vue?vue&type=style&index=0&id=728c69d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728c69d0",
  null
  
)

export default component.exports